import { Add, Visibility } from "@mui/icons-material"
import { Grid, Button, Typography } from "@mui/material"
import CreateProjectTemplateModal from "./CreateProjectTemplateModal"
import ShowActivitiesModal from "./ShowActivitiesModal"
import { useContext, useState } from "react"
import { useQuery } from "@apollo/client/react"
import { EssealDataTable } from "esseal-data-table";
import React from "react"
import projectTemplatesColumns from "./projectTemplateColumns"
import { GetProjectTemplatesDocument, PermissionActionEnum, PermissionEntityEnum, ProjectTemplate } from "@/graphql/generated/graphql"
import PermissionContext from "@/Contexts/Permissions"
import RequestPermissionTooltip from "@/components/RequestPermissionTooltip"

const ProjectTemplatesSection: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false)
  const { data, loading } = useQuery(GetProjectTemplatesDocument);
  const [showActivities, setShowActivities] = useState<boolean>(false);
  const [selectedTemplate, setSelectedTemplate] = useState<ProjectTemplate>({} as ProjectTemplate);
  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const { Create } = PermissionActionEnum;
  const { Projects } = PermissionEntityEnum;
  const hasPermission = canPerformAction(Create, Projects);

  const handleShowActivities = (template: ProjectTemplate) => {
    setSelectedTemplate(template);
    setShowActivities(true);
  };

  return (
    <Grid size={12}>
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#E3F1FF', paddingX: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Templates</Typography>
        <RequestPermissionTooltip
          hasPermission={hasPermission}
          requiredPermission={{ action: Create, entity: Projects }}
          checkRequestExists={checkRequestExists}
          onRequest={requestPermission}
        >
          <Button color="primary" onClick={() => setOpen(true)} startIcon={<Add />} disabled={!hasPermission}>
            New Template
          </Button>
        </RequestPermissionTooltip>
      </Grid>

      <EssealDataTable
        rows={data?.getProjectTemplates as ProjectTemplate[] || []}
        columns={projectTemplatesColumns}
        checkboxSelection={false}
        loading={loading}
        pagination={true}
        pageSize={25}

        // Actions & Events
        rowActions={(row) => [
          {
            label: 'View',
            icon: <Visibility fontSize="small" />,
            tooltip: 'Show Activities',
            onClick: () => handleShowActivities(row),
          }
        ]}
      />

      {open && <CreateProjectTemplateModal handleClose={() => setOpen(false)} />}
      {showActivities && (
        <ShowActivitiesModal
          handleClose={() => setShowActivities(false)}
          activities={JSON.parse(selectedTemplate?.activities) || []}
        />
      )}
    </Grid>
  );
}

export default ProjectTemplatesSection
